import React, { useEffect, useState, createRef } from "react";
import { later } from "../models/utils";

export default function ExpandButton(props: { style?: any; isExpanded: boolean; setIsExpanded: (b: boolean) => void }) {
  const { style, isExpanded, setIsExpanded } = props;
  const ref1 = createRef<HTMLDivElement>();

  let caretClassName = "las caret"; // no itx
  if (isExpanded) {
    caretClassName += " isExpanded"; // no itx
  } else {
    caretClassName += " isCollapsed"; // no itx
  }

  return (
    <div
      style={{
        ...style,
        height: "100%",
        paddingTop: "3px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
    >
      <div
        ref={ref1}
        key={`caret-${isExpanded ? "expanded" : "collapsed"}`}
        className={caretClassName}
        tabIndex={-1}
        style={{
          ...style,
          fontSize: "30px",
        }}
        id={`caret`}
        onClick={async (ev) => {
          ev.stopPropagation(); // prevent event bubbling to parent elements

          if (ref1.current) {
            ref1.current.style.color = "orange";
            ref1.current.className = caretClassName + " la-spin"; // no itx
          }

          later(() => {
            setIsExpanded(!isExpanded);
          });
        }}
        onFocus={(ev) => ev.target?.blur()}
      ></div>
    </div>
  );
}
